define.alias("ember-drag-sort/components/drag-sort-item", "preview-grid/components/drag-sort-item");